import { GetterTree } from 'vuex'
import RegisterState from './states'
import { State } from '@/store/store'

const getters: GetterTree<RegisterState, State> = {
  getLoginStatus: (state) => {
    return state.loginStatus
  },
  getUserId: (state) => {
    return state.userId
  },
}

export default getters
